import script from "./LoadingView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingView.vue?vue&type=script&setup=true&lang=js"

import "./LoadingView.vue?vue&type=style&index=0&id=65f2eafb&lang=scss"

const __exports__ = script;

export default __exports__